import { Env } from '@app/env';

export const environment: Env = {
  production: false,
  name: 'dev',
  region: 'us-east-1',
  version: '0.0.0',
  showDemoNcpdps: true,

  defaultOffsetFromUtc: 8,
  fixedDateMs: '2022-05-18T00:00:00Z',

  shortDomain: 'bscp.io',
  publicBucket: 'brightscrip-public-dev',
  configBucket: 'brightscrip-config-dev',
  patientsBucket: 'brightscrip-patients-dev',
  pharmaciesBucket: 'brightscrip-pharmacies-dev',
  brightscoreIndexName: 'brightscore_testing',

  // nosemgrep: generic.secrets.security.detected-generic-api-key.detected-generic-api-key
  captchaApiKey:
    'h7ZJVXbRfJiAZ5mnEetMxZPxZG6bwxwhVg+Cekr4ZlAk/UOcIxmWIX/tGJJicbuya7xQ0B+5d7bL7GEo6pLDeJNORoRH7zaIJhzwwzxDTOhS0mRfG2WGU7MAEj/FoiNYmUp/Q3I0RkOrPDbG+vL0JIE93N3Y+q+LMKLRbLOshTqtmxkhEsxYqAH9huu50PoJi/sQZ5QclHaW45MzQxzJ8OK6M+lzvc7gdYzjkRp1jLz4tykkzH2wc5hSoqVde8iuLAqWW1x6LHTIqyPS8atbTMZgSjjFKj/NbDK4qKwDpDW6lHKPJuO8oGJe3rO8YsN9DxHYqhlkmWVA+ABkLhVbtebzcWVXsWK//EbFNu6+/KzB59JGiVvpXULX8dk+eK4lkxTY1Zx5nXAWsWhQbeWygeg45D014tIFeVMybOX0VFEwcrqGpyqoUwr77w+dTfSfVS+84CzEkRVCOlpAAHOWqiIN/THZfWBq8fVBw3YeAoCCXBrweGz1ppIRV0bmhTiLZp/tVmhVfGzSC9P/RS4kdtp0loqTc4KFS8aCCLQuz4cQzcDHqc95SbxkZwxsFm518tPnzQBRmB4Hq8Pigk5cApXunqYKnVFOqJOkRekTFjyjt5Dboe5nvC79ojlAuACyKQCayeu0FPXWldyJoSl0xyoVgkqXVJQKMYgsHosMYEU=_0_1',
  captchaUrl: 'https://7bbf66d2de7e.us-east-1.captcha-sdk.awswaf.com/7bbf66d2de7e/jsapi.js',
  captchaEnabled: true,
  sentry: {
    enabled: true,
    dsn: 'https://3b3e923fb30c4e4098f149fb7ee4bc5e@o282441.ingest.sentry.io/6567854',
  },

  cognito: {
    userpoolId: 'us-east-1_8IsnKZ7pg',
    appClientId: '7u365q4fg0ien0qm5f2t5t8f9',
  },

  cartoApiKey: 'cb1_2mg7_1_6f7b7902c823010560925147', // gitleaks:allow -- public key, shipped in the browser bundle

  openSearchUrl: 'https://ypxayjch8a.execute-api.us-east-1.amazonaws.com/dev/index',

  codeRequestUrl: 'https://copay-code-requests-api-dev.monarchsp.com/dev',
  dataDeliveryUrl: 'https://data-delivery-api-dev.monarchsp.com/dev',
  paymentUrl: 'https://sbgredeq3e.execute-api.us-east-1.amazonaws.com/dev',
  devOpsUrl: 'https://kg13cl15eb.execute-api.us-east-1.amazonaws.com/dev',
  etlUrl: 'https://etl-api-dev.monarchsp.com/dev',
  supportUrl: 'https://whvchy321e.execute-api.us-east-1.amazonaws.com/dev',

  authUrl: 'https://4pquydua93.execute-api.us-east-1.amazonaws.com/dev',
  aggregatesUrl: 'https://ypxayjch8a.execute-api.us-east-1.amazonaws.com/dev',
  copayUrl: 'https://marshc9vde.execute-api.us-east-1.amazonaws.com/dev',
  masterDataUrl: 'https://gz0co9wijj.execute-api.us-east-1.amazonaws.com/dev',
  dataMaintenanceUrl: 'https://yyuosct8oi.execute-api.us-east-1.amazonaws.com/dev',
  paUrl: 'https://kx79ymp4gl.execute-api.us-east-1.amazonaws.com/dev',
  ncpdpUrl: 'https://i204abidw7.execute-api.us-east-1.amazonaws.com/dev',
  tableEditorServiceUrl: 'https://aiq6itme7h.execute-api.us-east-1.amazonaws.com/dev',
  tokenActionUrl: 'https://uymz24qdxe.execute-api.us-east-1.amazonaws.com/dev',
  rxTransactionSettingsUrl: 'https://el0ecfs2b4.execute-api.us-east-1.amazonaws.com/dev',
};
